import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import CheckoutProductListItem from '@/app-theme/components/checkout/CheckoutProductListItem.vue'
import CartCommon from '@/app-core/mixins/cart/cartCommon'
import Translatable from '@/app-core/mixins/translatable'
import FormDataCommon from '@/app-core/mixins/form/formDataCommon'
import SelectPaymentMethod from '@/app-theme/components/payment/common/SelectPaymentMethod.vue'
import PaymentMinimumOrderWarning from '@/app-theme/components/payment/common/PaymentMinimumOrderWarning.vue'
import GenericPaymentGateway from '@/app-theme/components/payment/GenericPaymentGateway.vue'
import PaymentTypeEnum from '@/app-core/api/enums/PaymentTypeEnum'
import VivaSmartPaymentGateway from '@/app-theme/components/payment/VivaSmartPaymentGateway.vue'
import CheckoutPaymentModel from '@/app-core/api/models/checkout/CheckoutPaymentModel'
import StoreCommon from '@/app-core/mixins/store/storeCommon'
import {clone} from '@/app-core/lib/utils/helper'
import QrCodeOrderData from '@/app-theme/components/common/QrCodeOrderData.vue'
import AnalyticsCommon from '@/app-core/mixins/analytics/analyticsCommon'
import VueTelInputVuetify from '@/app-theme/components/common/VueTelInputVuetify/VueTelInputVuetify.vue'
import {getRegionCodeForCountryCode} from 'awesome-phonenumber'
import ScheduledOrder from '@/app-theme/components/cart/ScheduledOrder.vue'
import OrderTypeSelector from '@/app-theme/components/cart/OrderTypeSelector.vue'
import OrderTypeEnum from '@/app-core/api/enums/OrderTypeEnum'
import CartComponents from '@/app-core/mixins/cart/cartComponents'
import VMapAutocompleteService from '@/app-theme/components/map/VMapAutocompleteService.vue'
import MapsCommon from '@/app-core/mixins/maps/mapsCommon'
import AddressCommon from '@/app-core/mixins/maps/addressCommon'
import {getContrastColor} from '@/app-core/lib/utils/color'
import VMap from '@/app-theme/components/map/VMap.vue'
import AccountAddEditAddressDialog from '@/app-theme/components/account/AccountAddEditAddressDialog.vue'
import CustomerModel from '@/app-core/api/models/customer/CustomerModel'
import AccountSelectAddressDialog from '@/app-theme/components/account/AccountSelectAddressDialog.vue'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'

export default {
  name      : 'CheckoutDetails',
  components: {
    AccountSelectAddressDialog,
    AccountAddEditAddressDialog,
    VMap,
    VMapAutocompleteService,
    OrderTypeSelector,
    ScheduledOrder,
    VueTelInputVuetify,
    QrCodeOrderData,
    VivaSmartPaymentGateway,
    GenericPaymentGateway,
    PaymentMinimumOrderWarning,
    SelectPaymentMethod,
    CheckoutProductListItem
  },
  directives: {},
  mixins    : [i18nRouteMeta, Translatable, MapsCommon, AddressCommon, CartComponents, CartCommon, FormDataCommon, StoreCommon, AnalyticsCommon],
  props     : {},
  enums     : {PaymentTypeEnum, OrderTypeEnum},
  dataStore : {
    AppCart    : 'App.Cart',
    AppStores  : 'App.Stores',
    AppType    : 'App.Type',
    AppPayments: 'App.Payments'
  },
  dataModel: CheckoutPaymentModel,
  data() {
    return {
      panel                      : null,
      loading                    : false,
      addEditAddressDialogVisible: false,
      selectAddressDialogVisible : false
    }
  },
  computed: {
    customerModel() {
      return this.model?.Customer
    },
    customerModelValidator() {
      return this.customerModel?.validator
    },

    addressModel() {
      return this.model?.Address
    },
    addressModelValidator() {
      return this.addressModel?.validator
    },

    address: {
      get() {
        return this.addressModel
      },
      set(value) {
        this.addressModel.setData(value)
        this.$forceUpdate()
      }
    }
  },
  watch: {
    'addressModel.Formatted': function (newVal, oldVal) {
      if (!this.AppConfig?.Marketplace?.SupportsDelivery || this.AppCart.OrderType !== OrderTypeEnum.DELIVERY) return

      if (newVal !== oldVal) {
        this.$nextTick(() => {
          this.$refs.form.validate()
        })
      }
    },

    'addressModel.Lat': function (newVal, oldVal) {
      if (!this.AppConfig?.Marketplace?.SupportsDelivery || this.AppCart.OrderType !== OrderTypeEnum.DELIVERY) return

      if (parseFloat(newVal) !== parseFloat(oldVal)) {
        this.$nextTick(() => {
          this.$refs.form.validate()
          this.confirmAddress()
        })
      }
    }
  },
  beforeCreate() {
  },
  created() {
    this.$bus.$emit('cart:get-data')
    this.$bus.$on('Auth:Login:Success', this.onLogin)
    this.$bus.$on('Auth:Logout:Success', this.onLogout)
    this.init()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off('Auth:Login:Success', this.onLogin)
    this.$bus.$off('Auth:Logout:Success', this.onLogout)
  },
  destroyed() {
  },
  methods: {
    getContrastColor,
    toLocaleUpperCase,
    clone,
    getRegionCodeForCountryCode,

    init() {
      this.$nextTick(() => {
        if (this.AppConfig.Checkout.SelectedProductsExpanded) this.panel = 0
        this.model.Payment = this.AppCart.PaymentMethod.Code
        this.model.QrData = this.AppQrData || null
        this.onLogin()
      })
    },

    onSelectTable() {
      this.$bus.$emit('select-table:show-dialog')
    },

    onLogin() {
      if (this.userIsAuthenticated && this.model) {
        this.customerModel.setData(this.user.Info)
        if (this.AppConfig?.Marketplace?.SupportsDelivery && this.userHasAddresses) this.addressModel.setData(this.userDefaultAddress)
      }
      this.setGACheckout()
    },

    onLogout() {
      if (this.model) {
        this.customerModel.Id = null
        this.addressModel.Id = null
      }
    },

    addAddress() {
      this.addEditAddressDialogVisible = true
    },

    onAddressSaveSuccess(data) {
      if (!data?.CustomerInfo) return
      this.user = new CustomerModel(data.CustomerInfo)

      if (this.userHasAddresses) this.addressModel.setData(this.user.Addresses[this.user.Addresses.length - 1])
    },

    selectAddress() {
      this.selectAddressDialogVisible = true
    },

    onAddressSelected(address) {
      if (!address) return

      this.addressModel.setData(address)
    },

    async confirmAddress() {
      if (this.AppCart.OrderType === OrderTypeEnum.COLLECTION) return

      if (!this.AppType.isQRScanApp && this.userIsAuthenticated && this.AppCart.OrderType === OrderTypeEnum.DELIVERY) {
        if (!this.userHasAddresses) {
          this.$bus.$emit('app:show-notification', {
            title: '',
            body : this.$t('Checkout.Details.DeliveryDetails.Notification.Select'),
            type : 'error',
            icon : ''
          })
          return
        }
      }

      if (!this.AppType.isQRScanApp && this.addressModel && this.addressModel.Lat && this.addressModel.Lng && this.AppCart.OrderType === OrderTypeEnum.DELIVERY) {
        const result = await this.isPlaceInsideDeliveryAreas(this.addressToPlaceObject(this.addressModel))
        if (!result) {
          this.$bus.$emit('app:show-notification', {
            title: '',
            body : this.$t('Checkout.Details.DeliveryDetails.Notification.OutOfBounds'),
            type : 'error',
            icon : ''
          })
          return
        }
      }

      return false
    },

    customerModelValidatorVuetifyFormFieldRules(field) {
      return this.customerModelValidator && this.customerModelValidator.vuetifyFormFieldRules(field) || []
    },

    addressModelValidatorVuetifyFormFieldRules(field) {
      return this.addressModelValidator && this.addressModelValidator.vuetifyFormFieldRules(field) || []
    },

    validateForm() {
      let retVal = false

      if (this.modelForm) retVal = this.modelForm.validate()

      this.isFormValid = retVal

      return retVal
    }
  }
}
